import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { inputClass } from '../ui/Field';
import type { ChoirEvent } from '../../types';
import { eventTitle, formatDate } from '../../utils/labels';
import { useApp } from '../../contexts/AppContext';
export const razlogi = ['Bolezen', 'Službene obveznosti', 'Družinske obveznosti', 'Študij / šola', 'Odsotnost iz kraja', 'Drugo'];
interface AbsenceModalProps {
  event: ChoirEvent | null;
  open: boolean;
  onClose: () => void;
}
export function AbsenceModal({
  event,
  open,
  onClose
}: AbsenceModalProps) {
  const {
    setRsvp,
    pushToast
  } = useApp();
  const [razlog, setRazlog] = useState<string>('');
  const [opomba, setOpomba] = useState('');
  const [potrjeno, setPotrjeno] = useState(false);
  useEffect(() => {
    if (open) {
      setRazlog('');
      setOpomba('');
      setPotrjeno(false);
    }
  }, [open, event?.id]);
  if (!event) return null;
  function poslji() {
    if (!event || !razlog) return;
    setRsvp(event.id, {
      status: 'ne_morem',
      razlog,
      opomba: opomba || undefined
    });
    setPotrjeno(true);
    pushToast('Odsotnost je bila sporočena vodstvu.');
  }
  return <Modal open={open} onClose={onClose} naslov={potrjeno ? 'Odsotnost je zabeležena' : 'Sporočilo o odsotnosti'} opis={potrjeno ? undefined : `${eventTitle(event)} · ${formatDate(event.datum, {
    weekday: true
  })} ob ${event.zacetek}`} noga={potrjeno ? <Button onClick={onClose} data-id="element-235" data-mp="3tl2jbp6jl3nh">Zapri</Button> : <>
            <Button variant="secondary" onClick={onClose} data-id="element-236" data-mp="3tizpeu29qqdh">
              Prekliči
            </Button>
            <Button onClick={poslji} disabled={!razlog} data-id="element-237" data-mp="3ok6e98agfbgh">
              Pošlji odsotnost
            </Button>
          </>} data-id="element-234" data-mp="3anj3o2pkwms3">
      {potrjeno ? <div className="py-4 text-center" data-id="element-238" data-mp="1u99pg1f1weez">
          <CheckCircle2Icon className="mx-auto h-10 w-10 text-green-500" strokeWidth={1.5} data-id="element-239" data-mp="3ua7n30uh60v7" />
          <p className="mt-3 text-sm font-medium text-ink" data-id="element-240" data-mp="3uckfk7xuztmi">
            Vodstvo je obveščeno, da vas ne bo na dogodku {eventTitle(event)}.
          </p>
          <p className="mx-auto mt-2 max-w-sm text-[13px] leading-relaxed text-ink-muted" data-id="element-241" data-mp="74gs4xs0ne25">
            Razlog: {razlog}. Opravičena odsotnost še vedno šteje kot odsotnost pri izračunu prisotnosti.
          </p>
        </div> : <div className="space-y-4" data-id="element-242" data-mp="h1lcqt67r1gu">
          <div data-id="element-243" data-mp="m2911732547d">
            <p className="mb-2 text-[13px] font-medium text-ink" data-id="element-244" data-mp="m1qy5rlw3rqh">Razlog odsotnosti</p>
            <div className="grid grid-cols-2 gap-2" data-id="element-245" data-mp="qszaowiint7v">
              {razlogi.map(r => <button key={r} type="button" onClick={() => setRazlog(r)} aria-pressed={razlog === r} className={`rounded-lg border px-3 py-2.5 text-left text-[13px] font-medium transition-colors duration-150 ease-out ${razlog === r ? 'border-green-300 bg-green-50 text-green-700' : 'border-line bg-white text-ink hover:bg-canvas'}`} data-id="element-246" data-mp="uvm4h2yqzo7p">
                  {r}
                </button>)}
            </div>
          </div>

          <div data-id="element-247" data-mp="10yh9egj9713y">
            <label htmlFor="opomba" className="mb-1.5 block text-[13px] font-medium text-ink" data-id="element-248" data-mp="10z0id7qxef5u">
              Opomba (neobvezno)
            </label>
            <textarea id="opomba" rows={3} value={opomba} onChange={e => setOpomba(e.target.value)} placeholder="Npr. Pridem lahko šele po 20.00." className={inputClass} data-id="element-249" data-mp="1sovilzgbnp9a" />
          </div>

          <p className="rounded-lg bg-canvas px-3 py-2.5 text-xs leading-relaxed text-ink-muted" data-id="element-250" data-mp="2ge6assjlwbbt">
            Opravičena odsotnost je zabeležena kot odsotnost tudi v statistiki prisotnosti — zbor mora
            delovati kot celota.
          </p>
        </div>}
    </Modal>;
}